import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {PutHealthRescheduleAppointments} from 'domain/usecases';
import {RemotePutHealthRescheduleAppointments} from 'data/usecases';
import {BookingFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makePutHealthRescheduleAppointments = (): PutHealthRescheduleAppointments =>
	new RemotePutHealthRescheduleAppointments(
		makeBFFApiUrl(BookingFlowEndPoints.healthScheduledAppointments),
		makeAuthorizeHttpClientDecorator(),
	);
